export default "__VITE_ASSET__Touo$dne__"